<div class="container my-5">
    <h1 class="container text-center mt-3">Quiénes somos</h1>
    <hr class="my-5">
    <p>Somos una Red de Congregaciones de Hermanas Católicas en México conformada en el año 2024 para la promoción, prevención y atención de la salud de personas de bajos recursos y sin seguros de salud en la ciudad de México y en áreas rurales del estado de México.</p>
    <p>Conformada por 4 Congregaciones:</p>

    <ul>
        <div class="row d-flex align-items-center justify-content-center">
            <div class="col-sm-12 col-md-3 col-lg-3 mb-4">
                <img src="assets/img/01carmelitas.jpg" alt="Logotipo de Carmelitas Misioneras de Santa Teresa" class="img-fluid marco-redondo">
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3 mb-4">
                <li><p><strong>Carmelitas Misioneras de Santa Teresa</strong>: con presencia en el hospital conocido como “Sanatorio Santa Teresa”, en ciudad de México y dos puestos de salud en el Estado de México, Santo desierto y Tenancingo.</p></li>
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3 mb-4">
                <img src="assets/img/02mejif.jpg" alt="Logotipo de Misioneras Eucarísticas de Jesús Infante y Nuestra Señora de Fátima" class="img-fluid marco-redondo">
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3 mb-4">
                <li><p><strong>Misioneras Eucarísticas de Jesús Infante y Nuestra Señora de Fátima</strong>: con presencia en “Hospitalito Gustavo Guerrero A.C”, en Ciudad de México</p></li>
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3 mb-4">
                <img src="assets/img/03caridad.jpg" alt="Logotipo de Misionera de la Caridad de María Inmaculada" class="img-fluid marco-redondo">
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3 mb-4">
                <li><p><strong>Misionera de la Caridad de María Inmaculada</strong>: Psiquiátrico “Lira y Serafín”, en Ciudad de México.</p></li>
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3 mb-4">
                <img src="assets/img/04franciscanas.jpg" alt="Logotipo de Hermanas Franciscanas de la Inmaculada Concepción" class="img-fluid marco-redondo">
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3 mb-4">
                <li><p><strong>Hermanas Franciscanas de la Inmaculada Concepción</strong>: “Sanatorio San Francisco de Asís”</p></li>
            </div>
        </div>
        
    </ul>

    <div class="row mt-5">
        <div class="col-sm-12 col-md-6 col-lg-6">
            <h2 class="text-center mb-3">Misión</h2>
            <p>Fortalecer la sinodalidad, prácticas y servicios del grupo interdisciplinario de la Red para la promoción del cuidado de la salud de las personas y comunidades con un enfoque de medicina integrativa, humanista, preventiva y formativa.</p>
            <img src="assets/img/wfoto02.jpg" alt="Grupo de personas en una iglesia" class="img-fluid">

        </div>
        <div class="col-sm-12 col-md-6 col-lg-6">
            <h2 class="text-center mb-3">Valores</h2>
            <ul>
                <li><p><strong>Responsabilidad</strong>: asumiendo el compromiso en nuestro quehacer con base al respecto de las diferencias de credo, ideas y formas de actuar.</p></li>
                <li><p><strong>Honestidad</strong>: transparencia en nuestro quehacer entre las integrantes y hacia las comunidades.</p></li>
                <li><p><strong>Comunión</strong>: participar en comunidad en el logro de objetivos compartidos.</p></li>
                <li><p><strong>Solidaridad</strong>: colaboración y empatía desde la mirada compasiva hacia la otra(o).</p></li>
            </ul>
        </div>

    </div>

</div>

<br class="mb-5">